import { ENDPOINTS } from '@config/endpoints';
import { ERROR_CODE } from '@config/errors';
import { HTTP_STATUS_CODE } from '@config/net';
import { BaseNetError } from '@errors/base-net-error';
import { authedJsonFetch, AuthedJsonFetchResult } from '@services/base/authed-json-fetch';
import { PaymentsGetCoinsPayDataRequestData, PaymentsGetCoinsPayDataRequestDto, PaymentsGetCoinsPayDataResponseData, PaymentsGetCoinsPayDataResponseDto } from '@services/dto/payments';
import { paymentsGetCoinsPayDataRequestToDto, paymentsGetCoinsPayDataResponseFromDto } from '@mapping/payments';
import { PAY_MODE, PAYMENT_METHOD_KEY } from '@types';
type PaymentsGetCoinsPayData = (requestData: PaymentsGetCoinsPayDataRequestData) => AuthedJsonFetchResult<PaymentsGetCoinsPayDataResponseData>;
export const paymentsGetCoinsPayData: PaymentsGetCoinsPayData = requestData => {
  const {
    promise,
    cancel
  } = authedJsonFetch<PaymentsGetCoinsPayDataResponseDto, PaymentsGetCoinsPayDataRequestDto>(ENDPOINTS.payments.settings(), {
    method: 'POST',
    data: paymentsGetCoinsPayDataRequestToDto(requestData)
  });
  return {
    promise: promise.then(paymentsGetCoinsPayDataResponseFromDto).then(data => {
      if (!data.recurrentPaymentInitiated && data.mode === PAY_MODE.FRAME && !data.frame.src && data.paymentMethodKey === PAYMENT_METHOD_KEY.CARD_MIR || !data.recurrentPaymentInitiated && data.mode === PAY_MODE.TAB && !data.tab.href && data.paymentMethodKey === PAYMENT_METHOD_KEY.CARD_MIR || !data.recurrentPaymentInitiated && data.mode === PAY_MODE.WINDOW && !data.window.href && data.paymentMethodKey === PAYMENT_METHOD_KEY.CARD_MIR) {
        throw new BaseNetError(HTTP_STATUS_CODE.BAD_REQUEST,
        //
        'Bad request', {
          data: null,
          errors: [{
            code: ERROR_CODE.PAYMENT_AGGREGATOR_MIR_ERROR,
            data: undefined
          }]
        });
      }
      if (!data.recurrentPaymentInitiated &&
      //
      data.mode === PAY_MODE.FRAME && !data.frame.src || !data.recurrentPaymentInitiated &&
      //
      data.mode === PAY_MODE.TAB && !data.tab.href || !data.recurrentPaymentInitiated &&
      //
      data.mode === PAY_MODE.WINDOW && !data.window.href) {
        throw new BaseNetError(HTTP_STATUS_CODE.BAD_REQUEST,
        //
        'Bad request', {
          data: null,
          errors: [{
            code: ERROR_CODE.PAYMENT_AGGREGATOR_ERROR,
            data: undefined
          }]
        });
      }
      return data;
    }),
    cancel
  };
};